import React from 'react'

import { FormattedMessage } from 'react-intl'
import { shallowEqual, useSelector } from 'react-redux'
import { useLocation, useRouteMatch } from 'react-router-dom'

import Loading from '@components/UI/Loading'
import { BillingTypes } from '@enums'
import { IApplicationState } from '@store'
import { selectIsFetchingBilling, selectPurchaseListByMonth } from '@store/billings'
import { selectBillingType, selectCampaignId } from '@store/router'
import Theme from '@theme'
import { H3 } from '@tribegroup'
import PurchaseBreakdown from './Breakdown/Breakdown'
import PurchaseCampaignWrapper from './Wrapper/CampaignWrapper'
import PurchaseContentLibraryWrapper from './Wrapper/ContentLibraryWrapper'

const Purchase: React.FC = () => {
  const match = useRouteMatch()
  const location = useLocation()

  const { billingType, purchasesByMonth, isLoading } = useSelector((state: IApplicationState) => {
    const campaignId = selectCampaignId(match) as number
    const billingType = selectBillingType(location)
    return {
      billingType,
      purchasesByMonth: selectPurchaseListByMonth(state, billingType, campaignId),
      isLoading: selectIsFetchingBilling(state),
    }
  }, shallowEqual)

  const PurchaseWrapper =
    billingType === BillingTypes.Campaigns ? PurchaseCampaignWrapper : PurchaseContentLibraryWrapper

  return (
    <PurchaseWrapper>
      <H3
        color={Theme.grey900Color}
        topOuterSpacing={0.5}
        bottomOuterSpacing={2.5}
        leftOuterSpacing={0.625}
      >
        <FormattedMessage id={`core.text.purchases.${billingType}`} />
      </H3>
      {isLoading ? (
        <Loading />
      ) : (
        Object.keys(purchasesByMonth).map((month) => (
          <PurchaseBreakdown
            key={`breakdown-${month}`}
            month={month}
            purchases={purchasesByMonth[month]}
          />
        ))
      )}
    </PurchaseWrapper>
  )
}

export { Purchase }
export default Purchase
